<div class="mt-3">
    <label for="authors-dropdown" class="form-label">{{ label | translate }}</label>
    <div class="input-group dynamic-dropdown">
        <input
            id="authors-dropdown"
            class="form-control"
            type="text"
            #textInput
            [(ngModel)]="displayValue"
            (input)="onInput()"
            (click)="openDropDown()"
        />
        <div class="d-flex" (click)="onCaretClick()">
            <fa-icon [icon]="faCaretDown" class="input-group-text"></fa-icon>
        </div>
    </div>
    @if (showDropDown && filteredOptions.length > 0) {
        <div class="dropdown-wrapper">
            @for (option of filteredOptions; track option) {
                <div class="dropdown-item" (click)="onSelectChange(option)">{{ option }}</div>
            }
        </div>
    }
</div>
